import styled, { CreateStyled } from '@emotion/styled'
import { ThemeType } from './theme'

/**
 * CreateStyled applies the theme type to emotion's styled component
 * theme prop.
 *
 * @example
 * const Heading = styled.h1`
 *   color: ${props => props.theme.colors.SLATE};
 * `;
 */
export default styled as CreateStyled<ThemeType>
